export default {
  title: "",
  subtitle: "Colombian Companies Registration",
  path: "company_registration_co",
  paragraphs: [
    "In Colombia the document_type is going to be “nit” (a 10-digit). Below you can check a payload with initial required information. For other requirements depending on payment methods, check the table in section 'Information needed for registration (Companies)'"
  ],
  request: {
    payload: {
      "company": {
        "document_number": "8001972684",
        "document_type": "nit",
        "social_name": "Company's name",
        "fiscal_country": "Colombia",
      }
    },
    responses: {
      "data": {
        "updated_at": "2025-05-02T22:11:08.714019",
        "status": "approved",
        "social_name": "Company's name",
        "required_clearance_level": 1,
        "references": [],
        "phone_number": null,
        "partners": [],
        "net_value": null,
        "net_monthly_average_income": null,
        "main_activity": null,
        "inserted_at": "2025-05-02T22:11:08.672280",
        "id": "01cf5b70-569f-43f5-80a4-7af303c9c003",
        "fiscal_country": "Colombia",
        "email": null,
        "documents": [],
        "document_type": "nit",
        "document_number": "8001972684",
        "creation_date": null,
        "company_type": null,
        "company_name": null,
        "clearance_level": 1,
        "address_street": null,
        "address_state": null,
        "address_postal_code": null,
        "address_number": null,
        "address_neighborhood": null,
        "address_country": null,
        "address_complement": null,
        "address_city": null,
        "activity_type": null
      }
    }
  },
  parameterPayload: [
    {
      name: "company",
      type: "object",
      required: true,
      description: "An object containing:",
      is_parent: true
    },{
      name: "company.document_number",
      type: "string",
      required: true,
      description: "Company's Document number",
    },{
      name: "company.document_type",
      type: "string",
      required: true,
      description: "Must be nit",
    },{
      name: "company.social_name",
      type: "string",
      required: true,
      description: "Company's name",
    },{
      name: "company.fiscal_country",
      type: "string",
      required: true,
      description: "Chile",
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectCompanies/CompaniesRegistrationCO.js